import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "course-and-degree-certificate"
    }}>{`Course and Degree Certificate`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`Institutions offering degrees and certifications need to create many certificates of completion for their students. These certificates often include details about the student's performance and specific completed courses, which is tedious to create manually. Automation helps institutions create complex and personalized certificates quickly.`}</p>
    <p>{`Adobe Acrobat Services allows institutions to:`}</p>
    <ul>
      <li parentName="ul">{`Create standard branded templates for certificates`}</li>
      <li parentName="ul">{`Merge student-specific data and course information automatically into templates`}</li>
      <li parentName="ul">{`Protect documents from editing and sending`}</li>
      <li parentName="ul">{`Sign certificates automatically before sharing with students`}</li>
    </ul>
    <h3 {...{
      "id": "relevant-apis"
    }}>{`Relevant APIs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/pdf-services.md"
        }}>{`Adobe PDF Services API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/apis/doc-generation.md"
        }}>{`Adobe Document Generation API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.adobe.io/apis/documentcloud/sign.html"
        }}>{`Adobe Acrobat Sign API`}</a></li>
    </ul>
    <h3 {...{
      "id": "scenario"
    }}>{`Scenario`}</h3>
    <p>{`An executive education institution needs to create, sign, and send certificates to students upon completion of a program. Certificates include student information and course details that exist in their learning management system (LMS). Automating this process ensures accurate information is sent to the correct students quickly.`}</p>
    <h3 {...{
      "id": "building-this-solution"
    }}>{`Building this Solution`}</h3>
    <ol>
      <li parentName="ol">{`Create a simple data capture form using Microsoft Form (or another form builder)`}</li>
      <li parentName="ol">{`Design the course certificate template using Microsoft Word`}</li>
      <li parentName="ol">{`Use Adobe Document Generation Tagger in Word to place fields into the template based on the data model from the form`}</li>
      <li parentName="ol">{`Run the Adobe Document Generation API to merge data from the form into the template, creating a certificate in PDF`}</li>
      <li parentName="ol">{`Send to Adobe Acrobat Sign for the instructors’ signatures`}</li>
      <li parentName="ol">{`Send the final signed PDF to the student`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      